const SOUND_COOLDOWN_MS = 500;
const recentKeys = new Map();
let audio = null;
let lastPlayedAt = 0;

const soundUrl = () => `${process.env.PUBLIC_URL || ""}/tooltip.wav`;

export function playNotificationSound(eventKey = "") {
    if (typeof Audio === "undefined") return false;

    const now = Date.now();
    const key = String(eventKey || "notification");
    if ((recentKeys.get(key) || 0) + SOUND_COOLDOWN_MS > now) return false;
    if (lastPlayedAt + SOUND_COOLDOWN_MS > now) return false;

    recentKeys.set(key, now);
    lastPlayedAt = now;
    if (recentKeys.size > 200) {
        for (const [recentKey, playedAt] of recentKeys) {
            if (playedAt + 60000 < now) recentKeys.delete(recentKey);
        }
    }

    audio = audio || new Audio(soundUrl());
    audio.currentTime = 0;
    const playback = audio.play();
    playback?.catch?.(() => {
        // Browsers may reject sound until the first user interaction.
    });
    return true;
}

export function resetNotificationSoundForTests() {
    recentKeys.clear();
    audio = null;
    lastPlayedAt = 0;
}
